import classNames from 'classnames';
import React from 'react';
import styles from './StickyBottom.module.scss';
function StickyBottom({ noMargin = false, children }) {
    const classes = classNames(styles.wrap, { [styles.noMargin]: noMargin });
    return React.createElement("div", { className: classes }, children);
}
export default StickyBottom;
